import produce from 'immer';
import { ReducerAction } from 'store/modules/types';
import { toSelect } from 'utils/genericFunctions';
import { Types, consultaEspecie } from './types';

export const INITIAL_STATE: consultaEspecie = {
	status: 0,
	data: [],
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): consultaEspecie {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CONSULTA_ESPECIE_REQUEST: {
				break;
			}

			case Types.CONSULTA_ESPECIE_SUCCESS: {
				draft.status = action.payload.status;
				const select = toSelect(
					action.payload.data.especies,
					'descricao',
					'longId',
				);
				draft.data = select;
				break;
			}

			case Types.CONSULTA_ESPECIE_FAILURE: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			default:
		}
		return draft;
	});
}
